module.exports = require("core-js/library/fn/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/set-prototype-of.js
// module id = 119
// module chunks = 35783957827783 114276838955818 162898551421021